var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrash(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 22,
    height: 22,
    fill: "#777"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "trash_svg__a",
    d: "M9.154.5V2h4.308a.56.56 0 01.38.146A.482.482 0 0114 2.5s-.003.588-.003 1.04c0 .3-.227.46-.514.46H.543C.21 4 0 3.765 0 3.5v-1c0-.276.241-.5.538-.5h4.308V.5c0-.276.241-.5.539-.5h3.23a.56.56 0 01.382.146.482.482 0 01.157.354zM2.51 18C1.677 18 1 17.232 1 16.286V5h12v11.286c0 .946-.677 1.714-1.51 1.714H2.51zM3 7.5v8h1.5v-8H3zm3.25 0v8h1.5v-8h-1.5zm3.25 0v8H11v-8H9.5z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    transform: "translate(4.5 1)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "trash_svg__b"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#trash_svg__a"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#trash_svg__a"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#trash_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-4.5-2h90v90h-90z"
  })))));
}
export default SvgTrash;